export default {
  id: 90,
  title: 'Target #90 - Eclipse',
  url: 'https://cssbattle.dev/play/90',
  colors: ['#998235', '#F3AC3C', '#1A4341'],
  solution:
    '<a><style>body{background:#f3ac3c}a{position:fixed;top:150;left:0;width:400;height:400;background:#998235;border-radius:9in;box-shadow:0 -200px 0 -100px #1a4341,0 -202px 0 -76px #f3ac3c,0 -400px #998235}</style>',
}
